export default "__VITE_ASSET__DAsBmZQE__"